/** URL `?tab=` values for AMC contract overview. */
export const AmcContractOverviewTabParam = {
  OVERVIEW: "overview",
  LINE_ITEMS: "line-items",
  VISITS: "visits",
} as const;

export type AmcContractOverviewTabParamValue =
  (typeof AmcContractOverviewTabParam)[keyof typeof AmcContractOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, AmcContractOverviewTabParamValue> = {
  "1": AmcContractOverviewTabParam.OVERVIEW,
  "2": AmcContractOverviewTabParam.LINE_ITEMS,
  "3": AmcContractOverviewTabParam.VISITS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [AmcContractOverviewTabParam.OVERVIEW]: "1",
  [AmcContractOverviewTabParam.LINE_ITEMS]: "2",
  [AmcContractOverviewTabParam.VISITS]: "3",
};

export function amcContractOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForAmcContractOverviewTabId(
  tabId: string,
): AmcContractOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidAmcContractOverviewTabParam(
  tab: string | null,
): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
